import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="lot-activity-card"
//
// Controls the "Show all" expansion of a per-module activity card and
// reacts to a `lot-activity:show-all` window event dispatched by the
// activity heatmap. When the event's `cardKey` matches this card's
// `cardKeyValue`, the card expands, scrolls into view, and filters its
// rows to those matching the event's `date`.
export default class extends Controller {
  static targets = ["toggleButton", "recent", "expanded"]
  static values = {
    cardKey: String,
    showAllLabel: String,
    showLessLabel: String
  }

  connect() {
    this.boundExpandAndFilter = (event) => this.expandAndFilter(event)
    window.addEventListener("lot-activity:show-all", this.boundExpandAndFilter)
  }

  disconnect() {
    window.removeEventListener("lot-activity:show-all", this.boundExpandAndFilter)
  }

  toggle(event) {
    if (event) event.preventDefault()
    if (!this.hasExpandedTarget) return

    const isHidden = this.expandedTarget.classList.contains("hidden")
    if (isHidden) {
      this.#expand()
    } else {
      this.#collapse()
    }
  }

  expandAndFilter(event) {
    const { cardKey, date } = event.detail || {}
    if (cardKey !== this.cardKeyValue) return
    if (!this.hasExpandedTarget) return

    this.#expand()
    this.expandedTarget.querySelectorAll("[data-date]").forEach((row) => {
      row.classList.toggle("hidden", row.dataset.date !== date)
    })
    this.element.scrollIntoView({ behavior: "smooth", block: "start" })
  }

  clearFilter(event) {
    if (event) event.preventDefault()
    if (!this.hasExpandedTarget) return
    this.expandedTarget.querySelectorAll("[data-date]").forEach((row) => {
      row.classList.remove("hidden")
    })
  }

  #expand() {
    this.expandedTarget.classList.remove("hidden")
    if (this.hasRecentTarget) this.recentTarget.classList.add("hidden")
    if (this.hasToggleButtonTarget) {
      this.toggleButtonTarget.textContent = this.showLessLabelValue
    }
  }

  #collapse() {
    this.expandedTarget.classList.add("hidden")
    if (this.hasRecentTarget) this.recentTarget.classList.remove("hidden")
    if (this.hasToggleButtonTarget) {
      this.toggleButtonTarget.textContent = this.showAllLabelValue
    }
    // Also clear any heatmap-driven filter when collapsing.
    this.expandedTarget.querySelectorAll("[data-date]").forEach((row) => {
      row.classList.remove("hidden")
    })
  }
}
